import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { RootState } from '@/store';
import { ProductTypes } from '@/types/ecommerce.types';
import { useMediaQuery } from 'react-responsive';

const useHideShopifyHeader = (isZoomed?: boolean) => {
  const isPod = useFeatureFlagEnabled('pod');
  const { type } = useSelector((state: RootState) => state.product);
  const { currentFrame: galleryCurrentFrame } = useSelector((state: RootState) => state.gallery);
  const isGallery = type === ProductTypes.GALLERY;
  const isMobile = useMediaQuery({ maxWidth: 799 });

  useEffect(() => {
    if (!isGallery || !isMobile) return;

    const header = document.getElementById('shopify-section-header');
    if (!header) return;
    
    const shouldHide = isPod ? isZoomed : galleryCurrentFrame !== null;
    header.style.display = shouldHide ? 'none' : 'block';

    return () => {
      header.style.display = 'block';
    };
  }, [isGallery, isPod, isZoomed, galleryCurrentFrame]);
};

export default useHideShopifyHeader;
